import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class HtkoConfigService {

  constructor(private http: HttpClient) { }

  /**
   * Save HTKO configuration data
   * Action Code: 've1rvv'
   */
  saveData(
    baseUrl: string,
    settings: any,
    data: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const clobSettings: any = {
      sso_id: settings?.sso_id || globalService.sso_id || '',
      tax_year: settings?.tax_year || filterParams?.tax_year || globalService.tax_year || '',
      scenario: settings?.scenario || filterParams?.scenario || globalService.scenario || '',
      screen_key: settings?.screen_key || filterParams?.screen_key || globalService.screen_key || '',
      jcd_key: settings?.jcd_key || filterParams?.jcd_key || globalService.jcd_key || '',
      filer_entity_key: settings?.filer_entity_key || filterParams?.filer_entity_key || '',
      combination_key: settings?.combination_key || filterParams?.combination_key || ''
    };

    const jsonObj = JSON.stringify(data || []);
    const jsonSettings = JSON.stringify(clobSettings);

    let params: any = _.merge({}, globalService || {}, filterParams);
    params = _.extend({ clob_data: jsonObj }, params);
    params = _.extend({ clob_settings: jsonSettings }, params);

    params.sso_id = clobSettings.sso_id;
    params.tax_year = clobSettings.tax_year;
    params.scenario = clobSettings.scenario;
    params.screen_key = clobSettings.screen_key;
    params.jcd_key = clobSettings.jcd_key;
    params.filer_entity_key = clobSettings.filer_entity_key;
    params.combination_key = clobSettings.combination_key;
    params.scenarioCode = 'RAF';
    params.is_issue_key_enabled = 'N';

    // Build checkLockedbj array format: [{"combination_key":1423095}]
    const checkLockedbj: any[] = [];
    if (clobSettings.combination_key) {
      checkLockedbj.push({
        combination_key: parseInt(clobSettings.combination_key) || 0
      });
    }
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    const url = `${baseUrl}/saveJsonObject?action_code=ve1rvv`;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  /**
   * Check lock status for tax return
   * Action Code: 'n10cpv'
   */
  checkLockStatus(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalService: any,
    filterParams: any,
    modalName?: string
  ): Observable<any> {
    const params: any = {};
    
    params.action_code = 'n10cpv';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || globalService?.globalParams?.filer_entity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';

    this._applyModalDiscriminator(params, modalName);
    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Get code master data for basket dropdown
   * Action Code: 'dbty56'
   */
  getCodeMastData(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalService: any,
    filterParams: any,
    modalName?: string
  ): Observable<any> {
    const params: any = {};
    
    params.action_code = 'dbty56';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || globalService?.globalParams?.filer_entity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.p_jcd_key = p_jcd_key || filterParams?.p_jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.p_scenario = p_scenario || filterParams?.p_scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';

    this._applyModalDiscriminator(params, modalName);
    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Basket options for `genBranchForm1118ConfigNew` (same param shape as
   * `dbty56` / `getCodeMastData`, just a different `action_code`). This is
   * the legacy fast-path discovered in the original `gtw-ui-workspace`
   * source: the gen-branch variant of HTKO config never reused the SOURCE
   * basket from `dbty56` — it pulled its own dropdown from `q5wgil`. Restored
   * verbatim here so the consolidated single-screen UI can still render the
   * correct basket per toolbar action.
   *
   * Action Code: 'q5wgil'
   */
  getGenBranchBasketCodeMast(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalService: any,
    filterParams: any,
    modalName?: string
  ): Observable<any> {
    const params: any = {};

    params.action_code = 'q5wgil';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || globalService?.globalParams?.filer_entity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.p_jcd_key = p_jcd_key || filterParams?.p_jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.p_scenario = p_scenario || filterParams?.p_scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';

    this._applyModalDiscriminator(params, modalName);
    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Get HTKO config code master data
   * Action Code: 'lfmzzq'
   */
  getHtkoConfigCodeMast(
    baseUrl: string,
    globalService: any,
    filterParams: any,
    modalName?: string
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    params.action_code = 'lfmzzq';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || globalService?.globalParams?.filer_entity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || globalService?.globalParams?.parent_me_string || '';

    this._applyModalDiscriminator(params, modalName);
    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Get saved configuration data
   * Action Code: 'ynnh7m'
   */
  getSavedConfigData(
    baseUrl: string,
    scenario: string,
    globalService: any,
    filterParams: any,
    modalName?: string
  ): Observable<any> {
    const params: any = {};
    
    params.action_code = 'ynnh7m';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || '';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    params.scenario = scenario || filterParams?.scenario || globalService?.scenario || '';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || 'grid';
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || '';

    this._applyModalDiscriminator(params, modalName);
    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Get filer entity dropdown information
   * Action Code: '35gc5l'
   */
  getFilerEntityDropdown(
    baseUrl: string,
    tax_year: string,
    scenario: string,
    filing_group_key: string,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    params.action_code = '35gc5l';
    params.tax_year = tax_year || filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.filing_group_key = filing_group_key || filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';

    return this._makeLoadRequest(baseUrl, params);
  }

  /**
   * Optional defensive forwarding of the modal callback name as `modal_name`.
   *
   * The variant differentiation between `htkoForm1118Config` and
   * `genBranchForm1118ConfigNew` is actually handled on the frontend (see
   * `HtkoConfigComponent.showGeneralBranchContext`, `getConfigLineLabel()` and
   * the `q5wgil` basket call), exactly as it was in the legacy
   * `gtw-ui-workspace`. The legacy backend doesn't honor `modal_name` for
   * these action codes — both variants share `dbty56` / `lfmzzq` / `ynnh7m`
   * payloads. We still attach it as a no-op hint so any future server-side
   * filtering can pick it up without further client changes.
   */
  private _applyModalDiscriminator(params: any, modalName?: string): void {
    if (modalName) {
      params.modal_name = modalName;
    }
  }

  /**
   * Private helper method to make HTTP request
   * Builds URL with all parameters as query string and makes POST request
   */
  private _makeLoadRequest(baseUrl: string, params: any): Observable<any> {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    const url = `${baseUrl}/loadJsonObject?${urlParams.toString()}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, '', { headers, withCredentials: true });
  }

  /**
   * Generic getJSONObj method for backward compatibility
   * @deprecated Use specific action code methods instead (checkLockStatus, getCodeMastData, getHtkoConfigCodeMast, getSavedConfigData, getFilerEntityDropdown)
   */
  getJSONObj(
    baseUrl: string,
    requestParams: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams, requestParams);
    
    if (requestParams?.action_code) {
      params.action_code = requestParams.action_code;
    }
    
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || '';
    params.filing_group_key = filterParams?.filing_group_key || globalService?.filing_group_key || globalService?.globalParams?.filing_group_key || '';
    params.filer_entity_key = filterParams?.filer_entity_key || globalService?.filer_entity_key || globalService?.globalParams?.filer_entity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || globalService?.globalParams?.parent_me_string || '';
    
    // For action_codes 'n10cpv' and 'dbty56', ensure p_scenario and p_jcd_key are set from requestParams or fallback to scenario/jcd_key
    if (requestParams?.p_scenario !== undefined && requestParams?.p_scenario !== null && requestParams?.p_scenario !== '') {
      params.p_scenario = requestParams.p_scenario;
    } else {
      params.p_scenario = params.scenario;
    }
    
    if (requestParams?.p_jcd_key !== undefined && requestParams?.p_jcd_key !== null && requestParams?.p_jcd_key !== '') {
      params.p_jcd_key = requestParams.p_jcd_key;
    } else {
      params.p_jcd_key = params.jcd_key;
    }
    
    return this._makeLoadRequest(baseUrl, params);
  }

}

